import { mapMutations, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      services: 'additionalService/getServicesList',
      goods: 'additionalService/getGoodsList',
    }),

    isGorserv() {
      return (
        this.eventBlockIsLoaded &&
        this.services[this.$route.params.AdditionalServiceId].ExternalSystem === 'gorserv'
      );
    },

    cartCost() {
      const cost = this.goods
        .map((item) => item.Price * item.Quantity)
        .reduce((previousValue, currentValue) => previousValue + currentValue, 0);

      if (this.isGorserv) {
        return (cost < 1000 && cost !== 0 ? 1000 : cost).toFixed(2);
      }

      return cost.toFixed(2);
    },

    cartWeight() {
      return this.additionalService.goods
        .map((item) => item.Weight * item.Quantity)
        .reduce((previousValue, currentValue) => previousValue + currentValue, 0)
        .toFixed(2);
    },

    cartIsEmpty() {
      return this.cartCost === 0;
    },

    isEqualZero() {
      return this.good.Quantity > 0;
    },

    isLessRest() {
      // Если Rest === null, остаток не ограничен, возвращаем true
      if (this.good.Rest === null) {
        return true;
      }

      return this.good.Quantity < this.good.Rest;
    },

    isGoodsType() {
      return this.$route.params.type === 'goods';
    },

    typeShopText() {
      return this.isGoodsType ? this.$t('goods') : this.$t('services');
    },
  },

  methods: {
    ...mapMutations({
      changeGoodCount: 'additionalService/changeGoodCount',
    }),

    addToCart(val) {
      let currentCount = this.good.Quantity;
      // Если Rest === null, разрешаем добавлять любое количество (если count >= 0)
      if (this.good.Rest === null && currentCount + val >= 0) {
        this.changeGoodCount({ ID: this.good.ID, count: val + currentCount });
      } else if (currentCount + val >= 0 && currentCount + val <= this.good.Rest) {
        // Если Rest определён, проверяем, что новое количество не превышает остаток
        this.changeGoodCount({ ID: this.good.ID, count: val + currentCount });
      }
    },

    changeCart(value, event) {
      let count = +value;
      // Проверяем, что введено корректное неотрицательное число
      if (!/^([1-9]\d*|0)$/.test(count)) {
        count = 0;
        event.target.value = '0';
      } else {
        // Если Rest === null, разрешаем любое неотрицательное значение
        if (this.good.Rest === null) {
          event.target.value = count;
        } else {
          // Если Rest определён, ограничиваем count значением Rest
          count = Math.min(count, this.good.Rest);
          event.target.value = count;
        }
      }
      this.changeGoodCount({ ID: this.good.ID, count });
    },

    detectCartLine() {
      let cartIndex = window.innerHeight + window.pageYOffset + document.querySelector('footer').clientHeight;
      this.cartIsBottom = cartIndex >= document.body.offsetHeight;
    },
  },
};
